import { useEffect, useState } from "react";
import { Header, CustomCollapsible } from "../../components";
import { ReactComponent as RectangleMinus } from "../../assets/svgs/rectangle-minus.svg";
import { ReactComponent as RectanglePlus } from "../../assets/svgs/rectangle-plus.svg";
import useApp from "../../hooks/useApp";
import useNavigateWithQuery from "../../hooks/useNavigateWithQuery";
import { logAnalyticEvent } from "../../analytics";
import { EVENT_NAME, ROUTES } from "../../constants";
import { convertTimestamp } from "../../utils";
import "./styles.scss";

const FAQ = () => {
  const navigate = useNavigateWithQuery();
  const { selectedLanguage, tenantConfig } = useApp();

  const [startTime, setStartTime] = useState(0);
  const [openedIndex, setOpenedIndex] = useState(null);

  useEffect(() => {
    setStartTime(Date.now());
    return () => {
      const endTime = Date.now();
      logAnalyticEvent(EVENT_NAME.PAGE_VIEW, {
        page_title: ROUTES.FAQ,
        path: `${window.location.origin}/${ROUTES.FAQ}`,
        time_spent: convertTimestamp(endTime - startTime),
      });
    };
  }, []);
  return (
    <div className="faq-container">
      <Header backEnable onClick={() => navigate(-1)} />
      <div className="content-container">
        <h1 className="title">
          {tenantConfig?.faqs?.title[selectedLanguage?.value]}
        </h1>
        {!!tenantConfig?.faqs?.content.length &&
          tenantConfig?.faqs?.content[selectedLanguage?.value].map(
            (item, index) => {
              return (
                <CustomCollapsible
                  key={index}
                  isSVGIcon={true}
                  collapsibleWrapperClasses={"mx-0"}
                  cardHeading={item.question}
                  open={index === openedIndex}
                  onClick={() =>
                    setOpenedIndex((prev) => (prev === index ? null : index))
                  }
                  OpenedSVGIcon={RectangleMinus}
                  ClosedSVGIcon={RectanglePlus}
                >
                  <p className="card-text">{item.answer}</p>
                </CustomCollapsible>
              );
            }
          )}
      </div>
    </div>
  );
};

export default FAQ;
